"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcProxyInfoFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcProxyInfoFactory = /** @class */ (function (_super) {
    __extends(ArcProxyInfoFactory, _super);
    function ArcProxyInfoFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcProxyInfoFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ArcProxyInfoFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ArcProxyInfoFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcProxyInfoFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcProxyInfoFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcProxyInfoFactory;
}(contracts_1.ContractFactory));
exports.ArcProxyInfoFactory = ArcProxyInfoFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506102a5806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063204e1c7a1461003b578063f3b7dead1461006a575b600080fd5b61004e61004936600461021c565b61007d565b6040516001600160a01b03909116815260200160405180910390f35b61004e61007836600461021c565b610164565b6000806000836001600160a01b03166040516100a390635c60da1b60e01b815260040190565b600060405180830381855afa9150503d80600081146100de576040519150601f19603f3d011682016040523d82523d6000602084013e6100e3565b606091505b5091509150816101485760405162461bcd60e51b815260206004820152602560248201527f67657450726f7879496d706c656d656e746174696f6e28293a2063616c6c2066604482015264185a5b195960da1b60648201526084015b60405180910390fd5b8080602001905181019061015c919061023f565b949350505050565b6000806000836001600160a01b031660405161018a906303e1469160e61b815260040190565b600060405180830381855afa9150503d80600081146101c5576040519150601f19603f3d011682016040523d82523d6000602084013e6101ca565b606091505b5091509150816101485760405162461bcd60e51b815260206004820152601c60248201527f67657450726f787941646d696e28293a2063616c6c206661696c656400000000604482015260640161013f565b60006020828403121561022d578081fd5b813561023881610257565b9392505050565b600060208284031215610250578081fd5b8151610238815b6001600160a01b038116811461026c57600080fd5b5056fea2646970667358221220c73c697f67e55d4e6e0b2b081b224eec3f64c82667a970652f09f259c91f46e964736f6c63430008040033";
